import { ExternalApiData } from '@common/data-models/service/external-api-data';
import moment from 'moment-timezone';

export class ExternalApiDataPublicationList extends ExternalApiData {
    public record: any = {};
    constructor(
        public actionName: string,
        public database: string,
        public path: string,
        public guid: string,
        public userId: string,
        metaRec: StorytellingPublicationListRecord,
        channelSections: { [id: string]: Array<StorytellingPublicationRecord> }
    ) {
        super(actionName, database, path, guid, userId);
        if (metaRec) {
            this.record.Type = metaRec.Type;
            this.record.Path = metaRec.Path.fullPath;
            this.record.Guid = metaRec.Guid;
            this.record.PSTPublicationChannelGUID = metaRec.PSTPublicationChannelGUID;
            this.record.Title = metaRec.Title;
            this.record.PSTPublicationListRevisionNumber = metaRec.PSTPublicationListRevisionNumber;
            this.record.PSTPublicationChannelName = metaRec.Title;
            if (metaRec.PSTPublicationListTime) {
                this.record.PSTPublicationListTime = metaRec.PSTPublicationListTime.moment.utc().format();
            }
            const payloadSections: { [id: string]: Array<string> } = {};
            for (const section in channelSections) {
                payloadSections[section] = channelSections[section].map(item => item.linkedRecords[0].Guid);
            }
            this.record.PublicationSequenceCollection = payloadSections;
            if (metaRec.CreatedDateTime) {
                this.record.CreatedDateTime = metaRec.CreatedDateTime.moment.utc().format();
            }
            if (metaRec?.PSTPublicationListPublishedBy?.length > 0) {
                this.record.PSTPublicationListPublishedBy = metaRec.PSTPublicationListPublishedBy[0];
            }

            this.record.PSTPublicationEditionName = metaRec.PSTPublicationEditionName;
        }

        this.timestamp = moment(new Date()).utc().format();
    }
}
